import { SearchPlace, searchPlaceSchema } from '@/types/api/services/search';
import { Place, placeSchema } from '@/types/state/shared';
import { PlaceWithAssociation } from './AssociationDrawer.types';

export function adapter(input: SearchPlace | Place): PlaceWithAssociation {
  {
    const place = searchPlaceSchema.safeParse(input);

    if (place.success) {
      return {
        name: place.data.name,
        imageUrl: place.data.profileImageURL,
        address: {
          city: place.data.contact.address?.city,
          street: place.data.contact.address?.street,
        },
        associations: place.data.associations,
      };
    }
  }

  {
    const place = placeSchema.safeParse(input);

    if (place.success) {
      return {
        name: place.data.about.name,
        imageUrl: place.data.about.logo,
        address: {
          city: place.data.contact.address?.city,
          street: place.data.contact.address?.street,
        },
        associations: [],
      };
    }
  }

  return null;
}
